/* eslint-disable */
// import Libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

// import custom Components
import ContentWithNavigationSidebar from 'legacy/layouts/ContentWithNavigationSidebar';
import ContentHeader from 'legacy/containers/ContentHeader';
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent';
import EcgLoader from 'legacy/containers/EcgLoader';

import PageTab from '../../../legacy/components/PageTab';
import PageTabs from '../../../legacy/components/PageTabs';

import { UserProfileContext } from 'auth/contexts/UserProfileContext';
import { DATASOURCES, getDataSource } from 'state/services/utils';
import { checkIdtfFeatureEnabled } from 'configs';
import Paginator from '../../components/Table/Paginator';
import KardiaRxPatientResult from '../../containers/KardiaRxPatientResult';
import {
  getKardiaRxPatientsData,
  handleOnRefreshClick,
  getKardiaRxPatientsAutoComplete,
} from '../../state/kardiaRxIdtf/KardiaRxIDTFPatientsActions';
import KardiaRxSearchBar from '../../containers/KardiaRxSearch/KardiaRxSearchBar';

// import css
import styles from './KardiaRx.css';

/**
 * Page - KardiaRx - Patient Connection list
 *
 */
class KardiaRx extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      perPage: 249,
    };
  }
  UNSAFE_componentWillMount() {
    this.props.getKardiaRxPatientsData();
    this.props.getKardiaRxPatientsAutoComplete();
  }

  handleSetPageToDefault = () => {
    this.setState(
      {
        currentPage: 1,
      }
    );
  }


  handlePageChange = (page, action = 'click') => {
    this.setState(
      {
        currentPage: page,
      },
      () => {
        this.props.getKardiaRxPatientsData(false, 249, page);
      },
    );
  };

  render() {
    const {
      me,
      intl,
      refreshData,
      RX_PATIENTS_CONNECTION_LIST_STATE,
    } = this.props;

    const totalCount = RX_PATIENTS_CONNECTION_LIST_STATE &&
    RX_PATIENTS_CONNECTION_LIST_STATE.patients &&
    RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0] &&
    RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0] &&
    RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0].objectCount;
    const recordLenth =
    RX_PATIENTS_CONNECTION_LIST_STATE &&
    RX_PATIENTS_CONNECTION_LIST_STATE.patients &&
    RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0] &&
    RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0].participants &&
    RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0].participants.length;

    if (!checkIdtfFeatureEnabled(me)) {
      return (
        <ContentWithNavigationSidebar>
          <div data-page="kardiaRx" className={styles.KardiaRxPage}>
            <AccessDeniedContent
              // title={intl.formatMessage({ id: 'search.PageTitle' })}
              title="AliveCor Labs"
            />
          </div>
        </ContentWithNavigationSidebar>
      );
    }

    return (
      <ContentWithNavigationSidebar>
        <div data-page="kardiaRx" className={styles.KardiaRxPage}>
          <ContentHeader
            isLoading={me.isFetching}
            showLastRefresh={!me.isFetching}
            lastUpdated={
              RX_PATIENTS_CONNECTION_LIST_STATE.patients.dataLastUpdated
            }
            handleOnRefreshClick={refreshData}
            text="AliveCor Labs"
            enrollPatient = {true}
            showAddPatient = {false}
            me={me}
          />
          <React.Fragment>
            <KardiaRxSearchBar handleSetPageToDefault = {this.handleSetPageToDefault} />
            <div className={styles.kardiaPaginator}>
                <div style={{ marginLeft: 20 }}>
                  {' '}
                  SHOWING {recordLenth} OF {totalCount}{' '}
                </div>
                <div>
                  <Paginator
                    isLoading={RX_PATIENTS_CONNECTION_LIST_STATE.patients.isFetching}
                    currentPage={this.state.currentPage}
                    perPage={this.state.perPage}
                    totalRecords={
                      RX_PATIENTS_CONNECTION_LIST_STATE.patients &&
                      RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0] &&
                      RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0] &&
                      RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0].objectCount
                    }
                    onPageChange={this.handlePageChange}
                  />
                </div>
              </div>
            {RX_PATIENTS_CONNECTION_LIST_STATE.patients.isFetching ? (
              <EcgLoader />
            ) : (
              <React.Fragment>
                <div className={styles.pageTab}>
                  <PageTabs>
                    <PageTab
                      dataAction="KardiaRx Patients"
                      isActive={true}
                      // Disabling the count as of now. Can be enabled later
                      // getLabel={
                      //   RX_PATIENTS_CONNECTION_LIST_STATE.patients &&
                      //   RX_PATIENTS_CONNECTION_LIST_STATE.patients.data &&
                      //   RX_PATIENTS_CONNECTION_LIST_STATE.patients.data
                      //     .length &&
                      //   RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0]
                      //     .objectCount &&
                      //   RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0]
                      //     .objectCount !== undefined
                      //     ? () => (
                      //         <React.Fragment>
                      //           KardiaRx Patients
                      //           <div className={styles.badgeCount}>
                      //             {
                      //               RX_PATIENTS_CONNECTION_LIST_STATE.patients
                      //                 .data[0].objectCount
                      //             }
                      //           </div>
                      //         </React.Fragment>
                      //       )
                      //     : () => 'KardiaRx Patients'
                      // }
                      getLabel={() => 'KardiaRx Patients'}
                    />
                  </PageTabs>
                </div>
                <div className={styles.KardiaRxContainer}>
                  <KardiaRxPatientResult {...this.props} />
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        </div>
      </ContentWithNavigationSidebar>
    );
  }
}

KardiaRx.contextType = UserProfileContext;

const mapStateToProps = state => {
  const me = getDataSource(state, DATASOURCES.ME);
  const RX_PATIENTS_CONNECTION_LIST_STATE = state.kardiaRx.kardiaRxIDTFPatients;
  // const { form, search } = state;
  return {
    me,
    RX_PATIENTS_CONNECTION_LIST_STATE,
  };
};

const mapActionCreators = {
  getKardiaRxPatientsData,
  refreshData: handleOnRefreshClick,
  getKardiaRxPatientsAutoComplete,
};

export default connect(
  mapStateToProps,
  mapActionCreators,
)(injectIntl(KardiaRx));



// WEBPACK FOOTER //
// ./src/views/pages/KardiaRx/KardiaRx.jsx